import {
    Component,
    Input,
    OnInit,
    AfterViewInit,
    HostBinding,
    Output,
    EventEmitter
} from '@angular/core';

@Component({
    selector: 'app-decoration-pixelization-list',
    templateUrl: './decoration-pixelization-list.component.pug',
    styleUrls: ['./decoration-pixelization-list.component.less']
})
export class DecorationPixelizationListComponent implements AfterViewInit, OnInit {
    @Input() decorations: any[] = [];
    @Input() themes: any[] = [];

    @Output() close: EventEmitter<any> = new EventEmitter();

    @HostBinding('class.--animate-type-1') animate1 = false;
    @HostBinding('class.--animate-type-2') animate2 = false;
    @HostBinding('class.--show-all') showAll = false;

    public rarities: any[] = [];
    public ordinary: any[] = [];

    constructor(
    ) {
    }

    ngOnInit() {
        this.ordinary = this.decorations.reduce((list, item) => {
            if (item.decoration.rarity > 3) {
                this.rarities.push(item);
            } else {
                list.push(item);
            }

            return list;
        }, []);
    }

    async ngAfterViewInit() {
        await delay(0);
        if (this.rarities.length > 2) {
            this.animate2 = true;
        } else {
            this.animate1 = true;
        }

        const delayTime = 1000 + 3000 * this.rarities.length;
        await delay(delayTime);
        this.showAll = true;
    }

    onClose() {
        this.close.emit();
    }

    trackByFn(index, item) {
        return item._id;
    }
}

function delay(delayTime: number) {
    return new Promise((resolve) => setTimeout(resolve, delayTime));
}
